import type { FaireProductEntity } from "../../entity_types/product";

export const p_hw4zwr6eck: FaireProductEntity = {
  token: "p_hw4zwr6eck",
  type: "product",
  name: "KALO NOTE PAD",
  brandName: "Homegrown",
  imageUrl:
    "https://cdn.faire.com/fastly/87787cc91d2131c1d8695c2256e3755a374f51a9583638897d3de20a16358a59.jpeg",
  priceDollars: 3,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/23683f45b2c01450548ac0da46d1d60e1611eb128688f6bb12b63c331e00f9db.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
